import { Grid, Typography, styled } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";

import ButtonAction from "pages/Wallet/Component/ButtonAction";
import SearchInput from "components/SearchInput";
import useIsMobileView from "hooks/useIsMobileView";

const actionItems = [
  {
    value: "/deposit/1",
    text: "Deposit",
  },
  { value: "/withdraw/1", text: "Withdraw" },
  {
    value: {
      key: "transfer",
      extra: { transferSideId: 2 },
    },
    text: "Transfer",
  },
];

function MarketHeader({ value, onChange }) {
  const isMobileView = useIsMobileView();
  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  const [_, setSearchParams] = useSearchParams();

  const handleClickOnItems = (page) => {
    if (page.key) {
      const defaultCoin = 1;
      setSearchParams({ [page?.key || page]: defaultCoin, ...page?.extra });
    } else {
      navigate(page);
    }
  };

  return (
    <Grid container>
      <Grid item xs={12} mt={{ md: 6, xs: 2 }}>
        {isMobileView ? (
          <SearchInput value={value} onChange={onChange} />
        ) : (
          <>
            <Title component="h1">Market</Title>

            <Grid item xs={12} my={2}>
              <ButtonAction items={actionItems} onChange={handleClickOnItems} />
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  );
}

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  fontWeight: 700,
  color: theme.palette.text.main,
}));

export default MarketHeader;
